import React from 'react';

const MarkdownRenderer = ({ content }) => {
  const parseMarkdown = (text) => {
    if (!text) return '';
    
    // Convert markdown to HTML
    let html = text
      // Headers
      .replace(/^### (.*$)/gim, '<h3 class="text-xl font-semibold text-gray-900 mt-6 mb-3">$1</h3>')
      .replace(/^## (.*$)/gim, '<h2 class="text-2xl font-bold text-gray-900 mt-8 mb-4">$1</h2>')
      .replace(/^# (.*$)/gim, '<h1 class="text-3xl font-bold text-gray-900 mt-8 mb-6">$1</h1>')
      
      // Bold and Italic
      .replace(/\*\*(.*)\*\*/gim, '<strong class="font-semibold">$1</strong>')
      .replace(/\*(.*)\*/gim, '<em class="italic">$1</em>')
      
      // Links
      .replace(/\[([^\]]+)\]\(([^)]+)\)/gim, '<a href="$2" class="text-blue-600 hover:text-blue-800 underline">$1</a>')
      
      // Line breaks and paragraphs
      .replace(/\n\n/gim, '</p><p class="mb-4 text-gray-700 leading-relaxed">')
      .replace(/\n/gim, '<br>')
      
      // Horizontal rule
      .replace(/^---$/gim, '<hr class="border-gray-300 my-8">')
      
      // Lists (basic implementation)
      .replace(/^- (.*$)/gim, '<li class="ml-4 mb-1">• $1</li>');
    
    // Wrap in paragraph tags if not already wrapped
    if (!html.startsWith('<')) {
      html = `<p class="mb-4 text-gray-700 leading-relaxed">${html}</p>`;
    } else if (html.startsWith('<p')) {
      // Already starts with paragraph, just ensure proper closing
      html = html.replace(/<\/p>$/, '') + '</p>';
    }
    
    return html;
  };

  return (
    <div
      className="prose prose-lg max-w-none"
      dangerouslySetInnerHTML={{ __html: parseMarkdown(content) }}
    />
  );
};

export default MarkdownRenderer;